export const getDeliveries =`
query myQuery {
    listDeliverys(limit: 5000) {
      items {
        ASIN
        AmazonOrderId
        DeliveryID
        IsBusinessOrder
        IsReplacementOrder
        LatestShipDate
        NumberOfItemsUnshipped
        OrderStatus
        OrderType
        PurchaseDate
        SellerSKU
        PurchasedWithSupplier
        discountAtCheckout
        BadSKU
        TotalEarnings
      }
      nextToken
    }
  }
`;

export const getDeliveriesWithNextToken =`
query myQuery($nextToken : String) {
    listDeliverys(limit: 5000, nextToken: $nextToken) {
      items {
        ASIN
        AmazonOrderId
        DeliveryID
        IsBusinessOrder
        IsReplacementOrder
        LatestShipDate
        NumberOfItemsUnshipped
        OrderStatus
        OrderType
        PurchaseDate
        SellerSKU
        PurchasedWithSupplier
        discountAtCheckout
        BadSKU
        TotalEarnings
      }
      nextToken
    }
  }
`;

export const getDeliveriesWithOrders =`
query myQuery {
    listDeliverys(limit: 5000) {
      items {
        ASIN
        AmazonOrderId
        DeliveryID
        IsBusinessOrder
        IsReplacementOrder
        LatestShipDate
        NumberOfItemsUnshipped
        OrderStatus
        OrderItems {
            OrderItemId
            SellerSKU
            ASIN
            BadSku
            QuantityOrdered
            QuantityShipped
            TrackingId
            ShippingProvider
            ShippingType
          }
        OrderType
        TotalEarnings
        PurchaseDate
        SellerSKU
        PurchasedWithSupplier
        discountAtCheckout
        BadSKU
      }
      nextToken
    }
  }
`;

export const getDeliveriesWithOrdersWithNextToken =`
query myQuery($nextToken : String) {
    listDeliverys(limit: 5000, nextToken: $nextToken) {
      items {
        ASIN
        AmazonOrderId
        DeliveryID
        IsBusinessOrder
        IsReplacementOrder
        LatestShipDate
        NumberOfItemsUnshipped
        OrderStatus
        OrderType
        TotalEarnings
        OrderItems {
          OrderItemId
          SellerSKU
          ASIN
          BadSku
          QuantityOrdered
          QuantityShipped
          TrackingId
          ShippingProvider
          ShippingType
        }
        PurchaseDate
        SellerSKU
        PurchasedWithSupplier
        discountAtCheckout
        BadSKU
      }
      nextToken
    }
  }
`;

export const setBadSKU =`query setBadSKU($delsku: String!) {
  setBadSKU(delsku: $delsku)
}`

export const setPurchasedWithSupplier = `mutation setPurchasedWithSupplier($amazonOrderId: String!, $purchaseDate: String!, $purchased: Boolean!) {
  setPurchasedWithSupplier(amazonOrderId: $amazonOrderId, purchaseDate: $purchaseDate, purchased: $purchased)
}`

export const setDiscountAtCheckout = `mutation setDiscountAtCheckout($amazonOrderId: String!, $purchaseDate: String!, $discount: Boolean!) {
  setDiscountAtCheckout(amazonOrderId: $amazonOrderId, purchaseDate: $purchaseDate, discount: $discount)
}`
export const updateDiscountStatus = `
  mutation UpdateDelivery($input: UpdateDeliveryInput!, $condition: ModelDeliveryConditionInput) {
    updateDelivery(input: $input, condition: $condition) {
      __typename
      AmazonOrderId
      PurchaseDate
      discountAtCheckout
      TotalEarnings
    }
  }
`;

export const getTotalEarnings = `
  query GetTotalEarnings($amazonOrderId: String!) {
    getTotalEarnings(amazonOrderId: $amazonOrderId) {
      TotalEarnings
    }
  }
`;
